import React from "react";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { sto } from "../../../../Context/InshData";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";
import "../invoiceprint.css"

function FooterD(porps) {
  const { found, inv, premiApp, locInv } = porps;

  const clas = useInvAF();
  const sty = {
    cntr: { textAlign: "center", paddingTop: 10 },
    lft: { textAlign: "left", padingLeft: 5 },
    rit: { textAlign: "right", padingRight: 5 },
    dirR: {
      direction: "rtl",
      color: "black",
    },
    dirL: { direction: "ltr" },
  };
  return (
    <Grid container item style={sty.dirR}>
      <Grid container item style={sty.cntr} spacing={0}>
      </Grid>
      <Grid
        container
        item
        xs={12}
        spacing={1}
        style={{ paddingTop: 5, fontWeight: "bold", textAlign: "center" }}
      >
        <Grid container item xs={12} style={{ fontFamily: "Amiri-Regular" }}>
          {found.footer_img == null ? (
            <Grid item xs={12} container className={clas.footerA}>
              <Grid item xs={6} className={"invoice-footerar"}
              // className={clas.BdytotCntMmm}
              >
                {inv.notes}
              </Grid>
              <Grid item xs={6} className={"invoice-footerar"}
                style={styleFooterNotesAr} >
                {found.BillNotes}
              </Grid>
              <br />

            </Grid>
          ) : (
            (<Grid container item xs={12} justifyContent="center"
              style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm" }}>
              <div>
                <ButtonBase>
                  {" "}
                  <img
                    src={`data:image/jpeg;base64,${found.footer_img}`}
                    className={clas.headerImg}
                    alt={found.nameA}
                  />{" "}
                </ButtonBase>
              </div>
            </Grid>)
          )}
          {premiApp.billTemplate !== 11 && (
            <Grid item xs={12} container className={clas.footerNew}>
              <Grid item xs={2} style={{ fontFamily: "Amiri-Regular" }}>
                {sto.usernames}
              </Grid>
              <Grid item xs={2}>
                {locInv?.salesman}
              </Grid>
              <Grid item xs={4} style={{ fontFamily: "Amiri-Regular" }}>
                {" "}
                {"  البائع" + "     " + " Salesmans Sign "}
              </Grid>
              <Grid item xs={4} style={{ fontFamily: "Amiri-Regular" }}>
                {"توقيع المستلم" + "     " + " Receivrs Sign "}
              </Grid>
            </Grid>)}

        </Grid>

      </Grid>
    </Grid>
  );
}
export default FooterD;

